import React from 'react';

// Inputs
import { Table } from '../../../helpers';


const MaterialMasterInterim = (props) => {

    const categoryBody = (rowData) => {
        let relatedCategory = props.materialCategory.find(category => category.categoryId === rowData.categoryId)
        if(relatedCategory){
            return relatedCategory.categoryName
        }
        else{
            return "-"
        }
    }

    const brandBody = (rowData) => {
        let relatedBrand = props.materialBrands.find(brand => brand.brandId === rowData.brandId)
        if(relatedBrand){
            return relatedBrand.brandName
        }
        else{
            return "-"
        }
    }

    const createdByUserBody  = (row) => {
        if(row.users){
            let username = row.users.firstName
            if (row.users.lastName) {
                username += " " + row.users.lastName
            }
            return username
        }
        else{
            return "-"
        }
    }


    const tableColumns = [
        {
            header: 'Category',
            field: 'categoryName',
            style: { minWidth: '150px' },
            body: categoryBody
        },
        {
            header: 'Brand',
            field: 'brandName',
            style: { minWidth: '150px' },
            body: brandBody
        },
        {
            header: 'Product Name',
            field: 'productName',
            style: { minWidth: '150px' }
        },
        {
            header: 'Variant Name',
            field: 'variantName',
            style: { minWidth: '150px' }
        },
        {
            header: 'Specification',
            field: 'productSpecification',
            style: { minWidth: '150px' }
        },
        {
            header: 'UOM',
            field: 'UOM',
            style: { minWidth: '100px' }
        },
        {
            header: 'Created By',
            field: 'createdBy',
            style: { minWidth: '150px' },
            body: createdByUserBody
        },
    ]
    
    return (
        <div className="">
            <Table tableColumns={tableColumns} data={props.materialMasterInterimData} rows={10} />
        </div>
    );
};

export default MaterialMasterInterim;